<div class="SAS_Navbar">
  <!-- Header -->
  <app-outer-pages-header></app-outer-pages-header>

  <section class="about-jtc top-background no-printme">
    <div class="background-image">
      <div class="container">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb custom-breadcrumb">
            <li class="breadcrumb-item">
              <a [routerLink]="['/']">الرئيسية</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">من نحن</li>
          </ol>
        </nav>
        <h1 class="sub-title">نبذة عن المركز</h1>
      </div>
    </div>
  </section>

  <div class="intro2">
    <!-- <div class="container">
      <h4 class="sub-title"> نبذة <span> عن المركز </span> </h4>
    </div> -->

    <div class="container">
      <div class="WhoAreWe about-us">
        <!-- <h3 class="text-center heading-title mb-4 text-site-color">من نحن ؟</h3> -->
        <div class="section-title">
          <h2>من نحن ؟</h2>
        </div>

        <div class="row g-24">
          <!-- <div class="col-lg-4">
            <img
              src=".././../../assets/images/WhoWeAre.jpg"
              class="img-fluid img-thumbnail-edit"
            />
          </div> -->

          <div class="col-lg-8">
            <div class="about-content">
              <p>
                تأسست شركة سلاسة نهاية عام 2020م بأيدي سواعد وطنية مختصة في مجال
                اضطرابات التخاطب والسمع. واعتمدت الشركة في تأسيسها على أشخاص
                يحملون شهادات عليا من أهم الجامعات، وخبرات طويلة في أعرق
                المستشفيات؛ بغرض تهيئة كافة الوسائل، وإيجاد أفضل الحلول للمرضى
                الذين يعانون من اضطرابات في التخاطب أوالسمع .
              </p>
              <p>
                تسعى شركتنا لتوفير خدمات مختلفة للمرضى وبرامج مقدمة للعاملين
                والمعنيين بالتخصصات والمهتمين بها وذلك على النحو التالي :
              </p>

              <ul>
                <li>
                  <div>1) الخدمات المقدمة للمرضى من خلال :</div>
                  <ul class="w-list mr-3">
                    <li>
                      <a
                        [routerLink]="['/MedicalCenter']"
                        class="text-site-color"
                      >
                        a. المركز العلاجي
                      </a>
                    </li>
                    <li>
                      <a
                        [routerLink]="['/MedicalPlatform']"
                        class="text-site-color"
                      >
                        b. المنصة العلاجية
                      </a>
                    </li>
                    <li>
                      <a [routerLink]="['/Consultant']" class="text-site-color">
                        c. خدمة مستشارك في التخاطب
                      </a>
                    </li>
                  </ul>
                </li>
                <li>
                  2) الخدمات المقدمة للمختصين من خلال
                  <a href="#" class="text-site-color">برامج التدريب والتطوير</a>
                </li>
                <li>
                  3) الخدمات المقدمة للمعنيين من خلال
                  <a href="#" class="text-site-color">الدراسات والابحاث</a>
                </li>
                <li>
                  4) الخدمات المقدمة للمهتمين من خلال
                  <a href="#" class="text-site-color">الاحصائيات والمعلومات</a>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-lg-4">
            <img
              src=".././../../assets/images/WhoWeAre.jpg"
              class="img-fluid img-thumbnail-edit"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="VisionMessage">
      <div class="container">
        <!-- <div class="section-title">
          <h2>رؤيتنا</h2>
        </div> -->
        <div class="row">
          <!-- <div class="col-12">
            <div class="vision-card-new">
              <img src="assets/images/icons/eye.svg" alt="eye icon" />
              <p>
                أن تكون لنا الريادة محليا في خدمة المريض وجها لوجه (من خلال
                المركز العلاجي)، والتفضيل عالميا في خدمة المريض في مكانه عبر
                (منصة تفاعلية)، باستخدام أفضل الإجراءات والممارسات التشخيصية
                والعلاجية للحالات التي تعاني من اضطرابات التخاطب والسمع مع
                المتابعة المستمرة لها في أي وقت وأي مكان.
              </p>
            </div>
          </div> -->
          <div class="col-12">
            <div class="vision-card">
              <div class="icon">
                <img src="assets/images/icons/eye.svg" alt="eye icon" />
              </div>
              <h3>رؤيتنا</h3>
              <p>
                أن تكون لنا الريادة محليا في خدمة المريض وجها لوجه (من خلال
                المركز العلاجي)، والتفضيل عالميا في خدمة المريض في مكانه عبر
                (منصة تفاعلية)، باستخدام أفضل الإجراءات والممارسات التشخيصية
                والعلاجية للحالات التي تعاني من اضطرابات التخاطب والسمع مع
                المتابعة المستمرة لها في أي وقت وأي مكان.
              </p>
            </div>
          </div>
        </div>

        <!-- <div class="col-sm-12 col-lg-6">
            <div class="icon-container flex justfy-center pb-4">
              <i class="fas fa-check fa-5x icon-rounded bg-white text-site-color"></i>
            </div>
            <h3 class="text-center heading-title mb-4 text-white">رسالتنا</h3>
            <p class="font-size-lg text-white">أن تكون لنا الريادة محليا في خدمة المريض وجها لوجه (من خلال المركز العلاجي)، والتفضيل عالميا في خدمة المريض في مكانه عبر (منصة تفاعلية)، باستخدام أفضل الإجراءات والممارسات التشخيصية والعلاجية للحالات التي تعاني من اضطرابات التخاطب والسمع مع المتابعة المستمرة لها في أي وقت وأي مكان. </p>
          </div> -->
      </div>
    </div>

    <div class="container">
      <div class="OurStandards">
        <!-- <h3 class="text-center heading-title mb-4 text-site-color">قيمنا</h3> -->

        <!-- <div class="section-title">
          <h2>قيمنا</h2>
        </div> -->

        <div class="row g-24">
          <!-- <div class="col-sm-12 col-lg-4">
            <img
              src=".././../../assets/images/WhoWeAre.jpg"
              class="img-fluid img-thumbnail-edit"
            />
          </div> -->

          <div class="col-12">
            <div class="vision-card">
              <div class="icon">
                <img src="assets/images/icons/values.svg" alt="values icon" />
              </div>
              <h3>قيمنا</h3>
              <ul class="width-60">
                <li>
                  <img
                    src="assets/images/icons/check-icon-green.svg"
                    alt="check icon"
                  />
                  الالتزام بتعاليم وأخلاق الإسلام.
                </li>
                <li>
                  <img
                    src="assets/images/icons/check-icon-green.svg"
                    alt="check icon"
                  />

                  الجودة والتميز في رعاية المريض.
                </li>
                <li>
                  <img
                    src="assets/images/icons/check-icon-green.svg"
                    alt="check icon"
                  />

                  التعاون والعمل في فريق واحد.
                </li>
                <li>
                  <img
                    src="assets/images/icons/check-icon-green.svg"
                    alt="check icon"
                  />

                  الاحترام في جميع التعاملات.
                </li>
                <li>
                  <img
                    src="assets/images/icons/check-icon-green.svg"
                    alt="check icon"
                  />

                  سلامة وأمان المرضى والعاملين.
                </li>
                <li>
                  <img
                    src="assets/images/icons/check-icon-green.svg"
                    alt="check icon"
                  />

                  التحفيز والتشجيع لجميع العاملين.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <app-outer-pages-footer></app-outer-pages-footer>
</div>
